export default __webpack_public_path__ + "static/media/MO.f7db164c.svg";